export const wordpressFixFaqs = [
  {
    question: "How do I know whether my problem is a Quick Fix?",
    answer:
      "A Quick Fix usually has one visible symptom and one clear result, such as getting a broken form working, repairing a layout fault or correcting a specific plugin conflict. You do not need to choose perfectly—we review what you send and confirm the right package before you commit.",
  },
  {
    question: "Can you fix a WordPress website built by another developer?",
    answer:
      "Yes. We regularly investigate WordPress themes, plugins and integrations built or configured by other suppliers. We need suitable access and may recommend a separate diagnosis when the cause or condition of the website is unclear.",
  },
  {
    question: "Will the price change once you start?",
    answer:
      "The problem and outcome we agree with you are covered by the fixed price. If we uncover a separate issue or a wider requirement, we pause, explain it and quote before doing any additional work—there are no surprise extras.",
  },
  {
    question: "Do I need to send you my password?",
    answer:
      "Not through the enquiry form. We first review the problem, then arrange a secure way to share only the access needed for the agreed work. Depending on the fault, that might include WordPress, hosting, a staging site, error logs or a code repository.",
  },
  {
    question: "Can you help with checkout, forms and failed emails?",
    answer:
      "Yes. Typical work includes WooCommerce faults, missing or failed emails, Contact Form 7 integrations, theme layout problems, JavaScript conflicts, PHP compatibility issues, custom plugin repairs and import or export tools.",
  },
  {
    question: "Do you repair hacked WordPress websites?",
    answer:
      "We can assess security-related code and configuration changes, but a compromised website may need specialist incident response, hosting support or malware removal outside the standard Fix Desk packages. We will explain the safest route after an initial review and never offer an absolute security guarantee.",
  },
  {
    question: "Do you provide white-label WordPress support for agencies?",
    answer:
      "Yes. Design and marketing agencies can use Web Wonderland for confidential overflow troubleshooting, development and technical review. Reserved support allocations are available where recurring capacity is more suitable than individual fixes.",
  },
  {
    question: "Do you offer WordPress fixes outside Essex?",
    answer:
      "Yes. Web Wonderland is based in Chelmsford and supports businesses and agencies throughout Essex and across the UK using secure remote access, staging and review workflows.",
  },
]

export const automationSprintFaqs = [
  {
    question: "What does an automation sprint actually do?",
    answer:
      "It improves one repetitive business process without trying to replace everything at once. We map what starts the task, the rules, human exceptions and the result your team needs, then agree the price before building.",
  },
  {
    question:
      "Can an automation sprint really be delivered in ten working days?",
    answer:
      "Suitable One-Process Sprints are planned for ten working days or fewer once the scope, access, sample data and approvals are in place. More complex connected workflows or operational systems receive a specific schedule with the fixed quote.",
  },
  {
    question: "Can you work with the tools we already use?",
    answer:
      "Projects can involve Excel, Smartsheet, WordPress, WooCommerce, email, documents, databases, reporting tools and suitable third-party APIs. Feasibility depends on the quality of the data, available access and the interfaces provided by each system.",
  },
  {
    question: "What can a small business automate first?",
    answer:
      "Good first projects are repetitive, rules-based and currently consume measurable staff time. Examples include weekly reporting, order reconciliation, approval workflows, document data extraction, workload planning and moving information between systems.",
  },
  {
    question: "Are software and platform charges included?",
    answer:
      "The package covers the agreed Web Wonderland services. Any required third-party software, hosting, licences or usage charges are identified separately before implementation so the ongoing cost is visible.",
  },
  {
    question: "What if we discover the process needs something extra?",
    answer:
      "We agree the first result clearly so the price stays dependable. If a useful extra emerges, we explain it and either plan it as a later phase or quote it separately rather than quietly expanding the original sprint.",
  },
  {
    question: "Will our team receive documentation and a handover?",
    answer:
      "Yes. Every implementation package includes an appropriate handover and operating notes. Connected Workflow and Operational System packages include more detailed exception, configuration and support documentation.",
  },
  {
    question: "Do you provide automation services outside Essex?",
    answer:
      "Yes. Web Wonderland is based in Chelmsford and works with SMEs throughout Essex and across the UK. Discovery, implementation reviews and handover can be completed remotely where appropriate.",
  },
]

export const whiteLabelWordPressFaqs = [
  {
    question: "How does a white-label WordPress partnership work?",
    answer:
      "Your agency brings us in for agreed technical work while keeping the client relationship and commercial ownership. We complete the development, checks and handover behind the scenes, or take a limited client-facing role only when you ask us to.",
  },
  {
    question: "Will you approach our client directly?",
    answer:
      "No. We communicate with your agency and do not approach the end client unless a specific client-facing role has been agreed with you. Confidentiality, portfolio permissions and any NDA requirements are confirmed before sensitive project details are shared.",
  },
  {
    question: "Which WordPress tasks can the agency desk handle?",
    answer:
      "Typical work includes WooCommerce faults, Contact Form 7 and API integrations, Salient and WPBakery customisation, PHP compatibility, JavaScript conflicts, custom plugin repairs, import and export tools, performance-related code fixes and proportionate security-hardening changes.",
  },
  {
    question:
      "Can you work with our repository, staging site and project tools?",
    answer:
      "Yes. We can work with an appropriate source-control repository, staging environment and your preferred project-management workflow. If the inherited website lacks these foundations, we will explain the safest practical review and delivery route before work begins.",
  },
  {
    question: "What should we include in the first brief?",
    answer:
      "A project reference, available URL, the visible problem or required result, relevant steps, available files and the deadline are enough to begin. Keep passwords, API keys and access credentials out of the form—we arrange those securely later if needed.",
  },
  {
    question: "Will we know the cost before work begins?",
    answer:
      "The published packages have clear prices, but work only starts after the written deliverables, assumptions and acceptance criteria are confirmed. Larger builds, third-party costs and requirements outside the selected package are quoted separately before delivery.",
  },
  {
    question: "Do unused monthly development days roll over?",
    answer:
      "Reserved days protect delivery capacity during that month and do not automatically roll over. Priorities and dependencies are reviewed with your agency so the allocation can be used effectively, and any alternative arrangement must be agreed in writing.",
  },
  {
    question: "Can you provide white-label support outside Essex?",
    answer:
      "Yes. Web Wonderland is based in Chelmsford, Essex, and supports design, marketing and digital agencies throughout the UK using remote collaboration, secure access, staging and source-controlled delivery workflows.",
  },
]
